import React from "react";
import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import { AppProvider } from "./frontend/contexts/AppContext";

createInertiaApp({
    resolve: name => {
        const pages = import.meta.glob('./frontend/pages/**/*.tsx', { eager: true })

        return pages[`./frontend/pages/${name}.tsx`]
    },
    setup({ el, App, props }) {
        createRoot(el).render(<AppProvider><App {...props} /></AppProvider>)
    },
})